<template>
  <BContainer>
    <BRow>
      <BCol
        lg="6"
        order-lg="2"
        class="text-right pl-lg-5"
      >
        <cld-image
          public-id="v1557870539/state_of_visual_media/cloudinary-slide8.svg"
          alt="A hand holding a smartphone with sharing icons in speech bubbles surrounding it"
          fluid
          class="w-75 d-block mx-auto"
         />
        <h2 class="my-4">
          Customized visual hooks drive more social sharing
        </h2>
        <p>
          <strong>{{ numbers["word-of-mouth"] }}%</strong> of consumers identify word-of-mouth as a key influencer around purchases.<sup>4</sup>
          <span>&nbsp;Social shares are significant contributors to spreading the word—and they’re a champion of visual stories.<sup>5</sup></span>
        </p>
        <BRow>
          <BCol class="text-left" />
          <BCol>
            <v-popover popover-class="pp-20">
              <LearnMore />
              <template slot="popover">
                <cld-image
                  class="ml-4 mb-3"
                  public-id="v1560918237/state_of_visual_media/cloudinary-advantage.svg"
                  alt="Arrow pointing right"
                />
                <!-- <ChartDonut :dark="true" :num="numbers.visual" class="chart-donut ml-4"/> -->
                <div class="popover-title" style="margin: 0;">
                  <cld-image
                    class="tooltip-finger-icon"
                    public-id="v1557870041/state_of_visual_media/cloudinary-finger.svg"
                    alt="Icon of a hand with the index finger pointing up, representing a tool tip"
                  />
                  <p>Visual social shares have a <strong class="color-blue">{{ numbers.advantage }}%</strong> advantage over non-visual content</p>
                </div>
              </template>
            </v-popover>
          </BCol>
        </BRow>
      </BCol>
      <BCol
        lg="6"
        class="pr-lg-5"
      >
        <p>As social shares continue to be at the center of word-of-mouth branding and opportunities for improved engagement, delivering the right, optimized visual in a way that creates a high-quality experience for social is critically important.</p>
        <strong>Understanding social journeys</strong>
        <ul class="d-flex">
          <li>Slack</li>
          <li>WhatsApp</li>
        </ul>
        <GreyBox>
          <span>Apps for work and home aren’t as divided as you may expect</span>
        </GreyBox>
        <ChartLine :chartdata="chartableSocialWeek" />
        <div class="col-chart-outer">
          <label class="col-chart-label larger">Sunday</label>
          <label class="col-chart-label larger">Monday</label>
          <label class="col-chart-label larger">Tuesday</label>
          <label class="col-chart-label larger">Wednesday</label>
          <label class="col-chart-label larger">Thursday</label>
          <label class="col-chart-label larger">Friday</label>
          <label class="col-chart-label larger">Saturday</label>
          <label class="col-chart-label mobile">Sun</label>
          <label class="col-chart-label mobile">Mon</label>
          <label class="col-chart-label mobile">Tues</label>
          <label class="col-chart-label mobile">Wed</label>
          <label class="col-chart-label mobile">Thurs</label>
          <label class="col-chart-label mobile">Fri</label>
          <label class="col-chart-label mobile">Sat</label>
        </div>
        <!-- <div class="w-100" style="height: 400px; background: #baddad;"></div> -->
        <v-popover popover-class="pp-30">
          <LearnMore />
          <template slot="popover">
            <!-- <ChartDonut :dark="true" :num="numbers.visual" class="chart-donut ml-4"/> -->
            <div class="popover-title" style="margin: 0;">
              <cld-image
                class="tooltip-finger-icon"
                public-id="v1557870041/state_of_visual_media/cloudinary-finger.svg"
                alt="Icon of a hand with the index finger pointing up, representing a tool tip"
              />
              <p><strong>Another factor in effective visuals?</strong> How the image is <em>cropped</em> is critically important to its quality</p>
            </div>
            <cld-image
              class="m-4 mb-0"
              public-id="v1560918278/state_of_visual_media/cloudinary-crop.svg"
              alt="Outlined frames depicting different ways to crop the same image"
            />
          </template>
        </v-popover>
      </BCol>
    </BRow>
    <footer class="w-50">

    </footer>
  </BContainer>
</template>

<script>
import LearnMore from "../LearnMore.vue";
import GreyBox from "../greybox";
import ChartLine from "../line2.vue";

export default {
  components: {
    LearnMore,
    GreyBox,
    ChartLine
  },
  props: {
    numbers: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dataSocialWeek: {
      type: [Object, Array],
      default: () => [0]
    }
  },
  computed: {
    chartableSocialWeek() {
      function processNum(raw) {
        return Object.values(raw) // object to array
          .splice(1) // drop service name
          .map(parseFloat); // get numbers from strings
      }

      // console.log(this.dataSocialWeek);
      const numSlack = processNum(this.dataSocialWeek[0]);
      const numWhatsApp = processNum(this.dataSocialWeek[1]);
      // console.log(numSlack);
      // console.log(numWhatsApp);

      const color1 = "#0091ff";
      const color2 = "#f4b21b";

      let transformed = {
        datasets: [
          {
            data: numWhatsApp,
            backgroundColor: `rgba(${this.hexToRgb(color2)}, 0.75)`,
            borderColor: color2,
            borderWidth: 2,
            pointRadius: 0,
            fill: true
          },
          {
            data: numSlack,
            backgroundColor: `rgba(${this.hexToRgb(color1)}, 0.75)`,
            borderColor: color1,
            borderWidth: 2,
            pointRadius: 0,
            fill: true
          }
        ]
        // labels: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      };

      return transformed;
    }
  }
};
</script>

<style lang="scss" scoped>
.col-chart-outer {
  display: flex;
  padding: 4px 0.5em 0;
  justify-content: space-between;
  text-align: center;
}
.col-chart-label {
  display: none;
  &.larger {
    @include media-breakpoint-up(sm) {
      display: block;
    }
  }
  &.mobile {
    font-size: 12px;
    @include media-breakpoint-down(sm) {
      display: block;
    }
  }
  width: 12%;
}
label {
  font-size: 12px;
}

aside {
  margin-bottom: 1em;
  &:before {
    @include triangle(bottom, $lightgrey, 8px);
    position: absolute;
    left: 20%;
    top: 100%;
  }
}
.color-blue {
  color: $blue;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    margin-right: 1em;
    &:before {
      $dim: 12px;
      height: $dim;
      width: $dim;
      display: inline-block;
      margin-right: 0.25em;
      content: "";
    }
    &:nth-of-type(1):before {
      background: $blue;
    }
    &:nth-of-type(2):before {
      background: $gold;
    }
  }
}
</style>
